import { loadScript } from "./loadScript";
import type {
  NuveiSafeChargeGlobalOptions,
  NuveiSafeChargeInstance,
} from "./safecharge";

export const getNuveiSafeChargeSDKInstance = async (
  options: NuveiSafeChargeGlobalOptions
): Promise<NuveiSafeChargeInstance> => {
  const SafeCharge = await loadScript(
    "https://cdn.safecharge.com/safecharge_resources/v1/websdk/safecharge.js",
    "SafeCharge"
  );

  return SafeCharge(options);
};
